/** @jsxImportSource @emotion/react */


import { FooterStyle } from "./index.style";

export const Footer = () => {
    return (
    <div css={FooterStyle.index("ct")}>
      <div className="brandImg" />
    </div>
  );
};
